import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.203 4.598a4.314 4.314 0 0 1 6.264 0c1.71 1.78 1.71 4.653 0 6.433l-3.239 3.371a4.5 4.5 0 0 1-.878.71 4.31 4.31 0 0 1-5.387-.71 4.6 4.6 0 0 1-.603-.782.75.75 0 1 1 1.28-.782q.171.28.405.525a2.81 2.81 0 0 0 3.52.47q.31-.19.581-.47l3.24-3.371c1.152-1.2 1.152-3.156 0-4.355a2.814 2.814 0 0 0-4.102 0l-.713.742a.75.75 0 1 1-1.082-1.039z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.772 9.598a4.314 4.314 0 0 1 6.265 0q.349.364.603.782a.75.75 0 0 1-1.28.782 3 3 0 0 0-.405-.525 2.814 2.814 0 0 0-4.101 0l-3.24 3.371c-1.152 1.2-1.152 3.156 0 4.355a2.815 2.815 0 0 0 4.102 0l.714-.743a.75.75 0 0 1 1.081 1.04l-.714.742a4.314 4.314 0 0 1-6.264 0c-1.71-1.78-1.71-4.653 0-6.433z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }